export type OnlineErrorKind =
  | 'authentication'
  | 'authorization'
  | 'not-found'
  | 'rate-limit'
  | 'backup-egress'
  | 'server'
  | 'network'
  | 'timeout'
  | 'redirect'
  | 'invalid-response'
  | 'invalid-request'
  | 'hash-mismatch';

export interface OnlineErrorDetails {
  status?: number;
  retryAfter?: number;
  rateLimitScope?: string;
}

export class OnlineApiError extends Error {
  readonly kind: OnlineErrorKind;
  readonly details: OnlineErrorDetails;

  constructor(message: string, kind: OnlineErrorKind, details: OnlineErrorDetails = {}) {
    super(redactOnlineSecrets(message));
    this.name = 'OnlineApiError';
    this.kind = kind;
    this.details = details;
  }
}

export function redactOnlineSecrets(value: string): string {
  return value
    .replace(/zpk1_[A-Za-z0-9._~-]+/g, '[REDACTED]')
    .replace(/(authorization\s*:\s*bearer\s+)[^\s,;]+/gi, '$1[REDACTED]');
}
